import { type License, type Qualification } from "@clipboard-health/contract-worker-app-bff";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useWorkerQualifications } from "@src/appV2/Worker/useWorkerQualifications";
import { useMemo } from "react";

export interface WorkerQualificationWithLicenses {
  qualification: Qualification;
  licenses: License[];
}

export function useWorkerQualificationsWithLicenses(options?: {
  // Allow caller to avoid redundantly refetching on window focus
  refetchOnWindowFocus?: boolean;
}) {
  const {
    data: qualifications,
    isLoading: isQualificationsLoading,
    isError: isQualificationsError,
    isSuccess: isQualificationsSuccess,
    status,
  } = useWorkerQualifications(options);

  const { licenses } = useDefinedWorker();

  const data: WorkerQualificationWithLicenses[] = useMemo(() => {
    return (
      qualifications?.map((qualification) => ({
        qualification,
        licenses: licenses?.filter(
          (license) => license.attributes.qualification === qualification.attributes.name
        ),
      })) ?? []
    );
  }, [qualifications, licenses]);

  return {
    isLoading: isQualificationsLoading,
    isError: isQualificationsError,
    isSuccess: isQualificationsSuccess,
    status,
    data,
  };
}
